{
  "farsi": true,
  "focus": true,
  "timer": false
}
